import { queryClient } from '../query-client';
import { removeEmulationHeaders } from './emulate';

export function clearUsersData() {
  import('@sentry/react').then((Sentry) => Sentry.setUser(null));
  removeEmulationHeaders();
  queryClient.clear();
}
